import { Deserializable } from '../protocols/deserializable';
import { ProfileBadgeConfiguration } from '../users/dto/profile-badge-configuration';

export class Mentionable implements Deserializable {
  public id: number = 0;
  public firstName: string = '';
  public lastName: string = '';
  public profileBadgeConfiguration!: ProfileBadgeConfiguration;

  // Not from API
  public initials: string = '';
  public fullName: string = '';

  onDeserialize() {
    if (this.id === -1) {
      // This indicates that the author is the CSS Bot
      this.initials = '';
    } else {
      this.initials = `${this.firstName?.charAt(0)}${this.lastName?.charAt(0)}`;
    }
    this.fullName = `${this.firstName} ${this.lastName}`;

    if (this.profileBadgeConfiguration) {
      this.profileBadgeConfiguration = window?.injector?.Deserialize?.instanceOf(
        ProfileBadgeConfiguration,
        this.profileBadgeConfiguration
      );
    }
  }
}
